import { finalMissedRoute, todayMissedRoute, todayPendingRoute } from "../../../storage";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { driver_logout } from "../../../networking/urlEndPoints";
import { persistor } from '../../../services/store/store'
import { getStoredToken, FCM_TOKEN_STORAGE_KEY, FCM_TOKEN_SAVED_AT_KEY } from "../../../firebase";
import { clearLatestDriverPhotoUrl } from "../../slices/setting/driverProfilePhoto";

import Cookies from "js-cookie";
import Axios from "../../../networking/interceptor";

export const driverLogout = createAsyncThunk('driverLogout', async (_, { dispatch, rejectWithValue }) => {
	try {
		const fcmToken = getStoredToken();
		const response = await Axios.post(driver_logout, fcmToken ? { fcm_token: fcmToken } : {})
		const data = response.data
		dispatch(clearLatestDriverPhotoUrl())
		Cookies.remove('authToken')
		if (typeof localStorage !== 'undefined') {
			localStorage.removeItem(FCM_TOKEN_STORAGE_KEY);
			localStorage.removeItem(FCM_TOKEN_SAVED_AT_KEY);
		}
		window.location.href = '/'
		localStorage.removeItem(todayPendingRoute)
		localStorage.removeItem(todayMissedRoute)
		localStorage.removeItem(finalMissedRoute)
		Cookies.remove('$8h-76l#^*')
		Cookies.remove('verified')
		persistor.purge()
		return data;

	} catch (error) {
		return rejectWithValue(error.response)
	}
});
